import { useAppAuth } from "@/context/AppAuthContext";
import { Lock } from "lucide-react";

// Bloqueia a tela no app quando o administrador desmarcou a permissão (o servidor também recusa).
export const temPermApp = (session, ...chaves) => chaves.some((k) => session?.app_user?.[k] !== false);

export default function AppPermGuard({ perms, children }) {
  const { session } = useAppAuth();
  if (temPermApp(session, ...perms)) return children;
  return (
    <div className="py-14 text-center space-y-2" data-testid="app-sem-permissao">
      <Lock className="mx-auto text-slate-500" />
      <div className="text-sm font-semibold text-slate-300">Recurso não liberado</div>
      <div className="text-xs text-slate-500">Peça ao administrador da sua empresa para liberar esta permissão.</div>
    </div>
  );
}
